/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergenzaNonAllocatiDTO
 */
export interface EmergenzaNonAllocatiDTO {
    /**
     * 
     * @type {number}
     * @memberof EmergenzaNonAllocatiDTO
     */
    assistitiTotali?: number;
    /**
     * 
     * @type {number}
     * @memberof EmergenzaNonAllocatiDTO
     */
    assistitiAllocati?: number;
    /**
     * 
     * @type {number}
     * @memberof EmergenzaNonAllocatiDTO
     */
    readonly assistitiNonAllocati?: number;
}

/**
 * Check if a given object implements the EmergenzaNonAllocatiDTO interface.
 */
export function instanceOfEmergenzaNonAllocatiDTO(value: object): value is EmergenzaNonAllocatiDTO {
    return true;
}

export function EmergenzaNonAllocatiDTOFromJSON(json: any): EmergenzaNonAllocatiDTO {
    return EmergenzaNonAllocatiDTOFromJSONTyped(json, false);
}

export function EmergenzaNonAllocatiDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergenzaNonAllocatiDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'assistitiTotali': json['assistitiTotali'] == null ? undefined : json['assistitiTotali'],
        'assistitiAllocati': json['assistitiAllocati'] == null ? undefined : json['assistitiAllocati'],
        'assistitiNonAllocati': json['assistitiNonAllocati'] == null ? undefined : json['assistitiNonAllocati'],
    };
}

export function EmergenzaNonAllocatiDTOToJSON(value?: Omit<EmergenzaNonAllocatiDTO, 'assistitiNonAllocati'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'assistitiTotali': value['assistitiTotali'],
        'assistitiAllocati': value['assistitiAllocati'],
    };
}

